import { render, staticRenderFns } from "./StudioCommunityGroup.vue?vue&type=template&id=3334cb8c&scoped=true&"
import script from "./StudioCommunityGroup.vue?vue&type=script&lang=ts&"
export * from "./StudioCommunityGroup.vue?vue&type=script&lang=ts&"
import style0 from "./StudioCommunityGroup.vue?vue&type=style&index=0&id=3334cb8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3334cb8c",
  null
  
)

export default component.exports